const Error = () => {
  return <h1>Invalid URL!</h1>;
};

export default Error;
